const ERROR_TYPE_REGEX = /:\s/g;

/*
    This function try to extract the error type.
    In this context the error type is defined as, the text up to the first column we find - URLs are ignored.

    We use the result of this function as an error filter from the player to the Trends page.
    To provide more results to the customers we don't search the whole error text, but we try to extract the most meaningful part from the error.

    e.g. extractErrorTypeByText('Uncaught Reference Error: notDefinedVariable is not defined')
         returns 'Uncaught Reference Error'.

    @TODO: Improve precision. See tests for examples.
*/
export const extractErrorTypeByText = (errorText: string | undefined): string | null => {
  if (!errorText) {
    return null;
  }

  if (errorText.match(ERROR_TYPE_REGEX) === null) {
    return errorText;
  }

  const [errorType] = errorText.split(ERROR_TYPE_REGEX);

  return errorType;
};
